<template>
  <div id="china_map_box">
    <div id="china_map" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
var echarts = require("echarts");
export default {
  props: {
    userLoginAddress: Array,
  },
  data() {
    return {
      //全国省份数据
      dataList: [
        { province: "北京", value: 0 },
        { province: "南海诸岛", value: 0 },
        { province: "天津", value: 0 },
        { province: "上海", value: 0 },
        { province: "重庆", value: 0 },
        { province: "河北", value: 0 },
        { province: "河南", value: 0 },
        { province: "云南", value: 0 },
        { province: "辽宁", value: 0 },
        { province: "黑龙江", value: 0 },
        { province: "湖南", value: 0 },
        { province: "安徽", value: 0 },
        { province: "山东", value: 0 },
        { province: "新疆", value: 0 },
        { province: "江苏", value: 0 },
        { province: "浙江", value: 0 },
        { province: "江西", value: 0 },
        { province: "湖北", value: 0 },
        { province: "广西", value: 0 },
        { province: "甘肃", value: 0 },
        { province: "山西", value: 0 },
        { province: "内蒙古", value: 0 },
        { province: "陕西", value: 0 },
        { province: "吉林", value: 0 },
        { province: "福建", value: 0 },
        { province: "贵州", value: 0 },
        { province: "广东", value: 0 },
        { province: "青海", value: 0 },
        { province: "西藏", value: 0 },
        { province: "四川", value: 0 },
        { province: "宁夏", value: 0 },
        { province: "海南", value: 0 },
        { province: "台湾", value: 0 },
        { province: "香港", value: 0 },
        { province: "澳门", value: 0 },
      ],
      iaChart: "",
      widths: 0,
      options: {
        //标题
        title: {
          text: "全国统计",
          textStyle: {
            top: "100px",
            fontSize: 20,
            fontWeight: 500,
          },
        },
        //触发样式
        tooltip: {
          triggerOn: "mousemove", //mousemove、click
          padding: 8,
          borderWidth: 1,
          borderColor: "#409eff",
          backgroundColor: "rgba(255,255,255,0.7)",
          textStyle: {
            color: "#000000",
            fontSize: 13,
          },
          formatter(e) {
            let data = e;
            let context = `
                        <div>
                            <p><b style="font-size:15px;">${data.name}</b></p>
                            <p class="tooltip_style"><span class="tooltip_left">坐席数：</span><span class="tooltip_right">${data.value}</span></p>
                        </div>
                      `;
            return context;
          },
        },
        //视觉
        visualMap: {
          type: "piecewise",
          show: true,
          left: 0,
          bottom: 40,
          showLabel: true,
          //图标
          pieces: [
            {
              gte: 1000,
              label: ">= 1000",
              color: "#3D60F7",
            },
            {
              gte: 500,
              lt: 999,
              label: "500 - 999",
              color: "#3D60F7",
            },
            {
              gte: 100,
              lt: 499,
              label: "100 - 499",
              color: "#1E7DF2",
            },
            {
              gte: 10,
              lt: 99,
              label: "10 - 99",
              color: "#46B6F0",
            },
            {
              lt: 10,
              label: "<10",
              color: "#ADDEFF",
            },
          ],
        },
        //geo
        geo: {
          map: "china",
          scaleLimit: {
            min: 1.23,
            max: 2,
          },
          zoom: 1,
          top: 45,
          label: {},
          itemStyle: {
            areaColor: "#f2d5ad",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "坐席数",
            type: "map",
            geoIndex: 0,
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    //初始化中国地图
    initEchartMap() {
      let mapDiv = document.getElementById("china_map");
      let myChart = (this.iaChart = echarts.init(mapDiv));
      myChart.setOption(this.options);
    },
    //修改echart配制
    setEchartOption() {
      if (this.userLoginAddress.length) {
        this.dataList = this.userLoginAddress.map((item, index) => {
          return {
            name: item.province,
            value: Number(item.num),
          };
        });
      }
      this.options.series[0].data = this.dataList;
    },
  },
  created() {
    this.setEchartOption();
  },
  mounted() {
    this.initEchartMap();
    const that = this;
    window.onresize = () => {
      that.iaChart.resize();
    };
  },
  watch: {
    widths(newVal) {
      if (newVal) {
        this.initEchartMap();
      }
    },
  },
};
</script>

<style scoped>
#china_map_box {
  height: 100%;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
}
#china_map_box #china_map {
  height: 100%;
  width: 100%;
  /* transform:scale(1.3); */
}
#china_map_box .china_map_logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 45px;
}
#china_map .tooltip_style {
  line-height: 1.7;
  overflow: hidden;
}
#china_map .tooltip_left {
  float: left;
}
#china_map .tooltip_right {
  float: right;
}
</style>
